import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';
import { type CustomerExperimentValue } from '../../../../../../src/types/CustomerExperimentValue';

export type GetCustomerExperimentsResponse = {
  count: number;
  next: string | null;
  previous: string | null;
  results: CustomerExperimentValue[];
};

export interface Params {
  limit?: number;
  offset?: number;
}

export async function getCustomerExperiments({ limit = 999, offset }: Params) {
  const query = new URLSearchParams();

  if (limit !== undefined) {
    query.append('limit', limit.toString());
  }

  if (offset !== undefined) {
    query.append('offset', offset.toString());
  }

  return await send<GetCustomerExperimentsResponse>({
    path: '/api/v2/customers/self/experiments/',
    method: 'GET',
    query,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
